'use strict';
const angular = require('angular');

/**
 * Variables
 */

var adminBaseURL; // base url for making requests to admin Feedback API

/*@ngInject*/
export function FileUploadServiceService(baseConfigService, $http, $q) {
  adminBaseURL = baseConfigService.getAdminBaseURL();

  this.uploadFile = function(ngmodelfile, currentPolicy) {
    var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
    var deferred = $q.defer();
    var file = document.getElementById(`${ngmodelfile}`).files[0];

    if (!file) {
      console.error('No file selected');
      deferred.reject('No file selected');
      return deferred.promise;
    }

    return $http({
      method: 'POST',
      url: '/tocdev/api/data/get-signed-url',
      headers: {
          'Content-Type': 'application/json'
      },
      data: {
          fileName: file.name,
          fileType: file.type
      }
    })
    .then(response => {
      console.log('Signed URL:', response.data.url);
      
      return $http({
          method: 'PUT',
          url: response.data.url,
          data: file,
          headers: {
              'Content-Type': file.type,
              'x-amz-acl': 'public-read'
          },
          transformRequest: [(data) => data]
      });
    })
    .then(uploadResult => {

      const publicUrl = `https://gis-main-site.s3.us-west-2.amazonaws.com/${fileName}`
      return {
        url: publicUrl,
        ngmodel: ngmodel,
        ngmodelfile: ngmodelfile
      };
    });
  };

  this.clearFile = function(ngmodelfile) {
    var fileInput = document.getElementById(ngmodelfile);
    if (fileInput) {
      fileInput.value = '';
    }
  };


}

export default angular.module('appApp.FileUploadService', [])
  .service('FileUploadService', FileUploadServiceService)
  .name;


// WEBPACK FOOTER //
// ./client/components/services/fileUploadService/fileUploadService.js